import { render, staticRenderFns } from "./EditorRegister.vue?vue&type=template&id=f5c699ee&"
import script from "./EditorRegister.vue?vue&type=script&lang=js&"
export * from "./EditorRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports